<template>
  <fts-dropdown-select
    append-to-body
    :placement="placement"
    prevent-overflow-alt-axis
    prevent-overflow-tether-off
    content-class="dropdown-menu dropdown-menu-w-sm dropdown-menu--sticky activities-design-dropdown-menu"
    overlay
    class="fts-activities-design-dropdown"
    ref="dropdownSelect"
    @content:keydown-enter="optionPointerSelect"
    @content:keydown-up="optionPointerUp"
    @content:keydown-down="optionPointerDown"
    @selected="onSelect"
    @show="onShow"
    @hide="onHide"
  >
    <slot slot="toggle">
      <fts-btn
        outline
        text-transform-init
        class="activities-design-toggle"
      >
        <span>Add next step</span>
      </fts-btn>
    </slot>
    <template #menu="{ select }">
      <div class="dropdown-filter">
        <div class="fts-form-control-filter">
          <input
            class="fts-form-control"
            v-model="formData.name"
            placeholder="Create or select activity"
            ref="filterKeywordInput"
            @input="$v.formData.$touch()"
            @keyup.enter.prevent
            @keydown.up.prevent
            @keydown.down.prevent
          />
          <div class="search-icon">
            <font-awesome-icon :icon="['fas', 'search']" fixed-width />
          </div>
        </div>
      </div>

      <template v-if="$v.formData.name && !$v.formData.name.nonReserved">
        <div class="dropdown-validate-error">
          {{getActivityDesignError()}}
        </div>
      </template>

      <template v-for="(x, index) in getOptions">
        <div class="dropdown-label" :key="`label-${index}`" v-if="x.type === 'label'">
          {{x.value}}
        </div>

        <div
          class="dropdown-option"
          :class="{'dropdown-option--active': selectedIndex === index}"
          :key="`option-${index}`"
          @mouseenter="selectedIndex=index"
          @click="select(x)"
          :ref="`dropdown-option-${index}`"
          v-else
        >
          <fts-label-group
            :item="x.value"
            emoji
            :emoji-size="14"
          />
          <div class="dropdown-option-kbd-hint" v-if="x.type === 'create' && selectedIndex === index">
            <kbd>Enter</kbd> to create
          </div>
        </div>
      </template>
    </template>
  </fts-dropdown-select>
</template>

<script>
import Vue from 'vue';
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

import validator from '../commons/designValidator';

import FTSBtn from '../elements/FTSBtn';
import FTSDropdownSelect from '../elements/FTSDropdownSelect';
import FTSLabelGroup from '../elements/FTSLabelGroup';
import dropdown from '../commons/dropdown';

export default {
  components: {
    'fts-btn': FTSBtn,
    'fts-dropdown-select': FTSDropdownSelect,
    'fts-label-group': FTSLabelGroup
  },
  props: {
    placement: String,
    activities: Array
  },
  data: () => ({
    formData: {},
    selectedIndex: 0
  }),
  validations() {
    let formData = {};
    formData = validator.activityDesign(this.activities);
    return { formData };
  },
  methods: {
    onShow() {
      this.$nextTick(() => {
        this.$refs.filterKeywordInput.focus();
      });
    },
    onHide() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    onSelect(item) {
      if (item) {
        if (item.type === 'create') {
          this.$emit('option:create', item.value);
        } else if (item.type === 'select') {
          this.$emit('option:select', item.value);
        }
      }
    },
    optionPointerSelect() {
      if (this.selectedIndex > -1 && this.getOptions[this.selectedIndex]) {
        this.$refs.dropdownSelect.select(this.getOptions[this.selectedIndex]);
      }
    },
    optionPointerUp(item) {
      this.selectedIndex = dropdown.optionPointerUp({
        currentIndex: this.selectedIndex,
        options: this.getOptions,
        exclude: (x) => x && x.type !== 'label',
        scrollEl: item.popperContentEl,
        refs: this.$refs
      });
    },
    optionPointerDown(item) {
      this.selectedIndex = dropdown.optionPointerDown({
        currentIndex: this.selectedIndex,
        options: this.getOptions,
        exclude: (x) => x && x.type !== 'label',
        scrollEl: item.popperContentEl,
        refs: this.$refs
      });
    },
    getActivityDesignError() {
      return validator.activityDesignError(this.$v.formData, 'name');
    }
  },
  computed: {
    getOptions() {
      let options = [];
      let activities = Array.isArray(this.activities) ? this.activities : [];
      if (this.formData.name) {
        if (!this.$v.$invalid) {
          options = [
            { type: 'create', value: { name: this.formData.name }}
          ];
        }
        if (activities.length) {
          activities = activities.filter((x) =>
            x.name && x.name.toLowerCase().trim().indexOf(this.formData.name.toLowerCase().trim()) > -1
          );
        }
      }
      if (activities.length) {
        options = [
          ...options,
          { type: 'label', value: 'Activities' },
          ...activities.map((x) => ({ type: 'select', value: x }))
        ];
      }
      this.selectedIndex = options.indexOf(options.find(x => x.type !== 'label'));
      return options;
    }
  }
}
</script>

<style lang="scss">
.fts-activities-design-dropdown {
  .activities-design-toggle {
    &.fts-btn.fts-btn-outline:not(.disabled) {
      border: 2px dashed var(--fts-gray-300);
      > span {
        font-weight: 400;
      }
    }
  }
}
.activities-design-dropdown-menu {
  .dropdown-validate-error {
    padding: 0.25rem 0.75rem 0.75rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: var(--fts-text);
    &:not(:last-child) {
      margin-bottom: 0.5rem;
      border-bottom: 1px solid var(--fts-border);
    }
  }
}
</style>